var map = {
	"./andrealonso.svg": 37,
	"./ciudadlibre.png": 38,
	"./contact.png": 39,
	"./elgato.png": 40,
	"./five.svg": 41,
	"./liveshows.jpg": 42,
	"./looper.png": 43,
	"./mucen.png": 44,
	"./oscillosynth.svg": 45,
	"./sampler.svg": 46,
	"./stream.png": 47,
	"./swingometer.gif": 48,
	"./thigmophonic.jpg": 49,
	"./webrtc.svg": 50
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;